import Vue from 'vue'
// 所有组件的入口
import InfiniteScroll from './infinite-scroll'
import Button from './button/button.vue'
import LoadingBtn from './loadingBtn/loadingBtn.vue'

const install = (Vue) => {
  Vue.component(Button.name, Button)
  Vue.component(LoadingBtn.name, LoadingBtn)
  // 注册指令
  Vue.directive(InfiniteScroll.name, InfiniteScroll)
}

/**
 * 有可能组件会通过script标签引入
 * <script src='bkex-ui'></script>
 */
// if (typeof Window.Vue !== 'undefined') {
//   install(Vue) // 全局直接通过script 引用的方式会默认调用install方法
// }
// 非SSR时才会存在window对象
if (!Vue.prototype.$isServer) {
  if (typeof Window.Vue !== 'undefined') {
    install(Vue) // 全局直接通过script 引用的方式会默认调用install方法
  }
}

export default {
  install,
}
